export const ADD_USER_DATA = 'ADD_USER_DATA';
export const EDIT_USER_DATA = 'EDIT_USER_DATA';
export const CLEAR_FEEDBACK = 'CLEAR_FEEDBACK';
export const SHOW_PASSWORD_ASK_MODAL = 'SHOW_PASSWORD_ASK_MODAL';

export const CHANGE_COLOR_CONFIGURATION = 'CHANGE_COLOR_CONFIGURATION';
